import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Button, { ButtonTypes } from 'components/common/button';

import AttributesWithImages from './attributes_with_images';
import connect from 'components/lib/connect';
import { H2, H4 } from 'components/common/headers';
import { OrderTransactionDef, TransactionDefType } from 'models/configuration/transaction_def';
import { OrderAttributesPropTypes } from './order_transactions';
import { ProfileCardType } from 'models/configuration/profile_card_def';
import VisibleCustomAttribute from '../custom_attributes/visible_custom_attribute';
import GetExternalActionForm from 'actions/external_customer_lookup/get_external_action_form';

export const StyledOrderAttributes = styled.div`
  padding: 5px 20px 0px 20px;
`;

export const StyledOrderNumber = styled(H2)`
  margin-bottom: 8px;
  padding-left: 20px;
  padding-top: 15px;
`;

export const StyledNoteHeader = styled(H4)`
  padding: 20px 0 0 20px;
`;

export const StyledNoteBodyContainer = styled.div`
  background-color: ${p => p.theme.colors.gray100};
  border-radius: ${p => p.theme.borderRadius.default};
  margin: 0px 20px 15px 20px;
  max-height: 130px;
  overflow: auto;
  padding: ${p => p.theme.spacing.insetSmall};
`;

export class ExpandedOrderTransactionBase extends React.Component {
  render() {
    return (
      <div className="transaction-expandedInformation" ref={node => (this.expandedTransaction = node)}>
        <div className="transaction-expandedInformation-topTriangle" ref={node => (this.triangle = node)}>
          <div className="transaction-expandedInformation-topTriangle-border" />
        </div>
        {this.renderHeader()}
        {this.renderAttributes()}
        {this.renderNote()}
        {this.renderActions()}
      </div>
    );
  }

  renderOrderAttributes() {
    let hasAttributes = _.find(this.props.transactionDef.attributes, def => !!this.props.attributes[def.attr]);
    if (!hasAttributes) {
      return null;
    }

    return (
      <StyledOrderAttributes>
        {_.map(this.props.transactionDef.attributes, def => {
          const key = `optionalAttributes-${def.attr}`;
          return (
            <VisibleCustomAttribute
              className="transactionAttribute"
              def={def}
              key={key}
              value={this.props.attributes[def.attr]}
              location={{ type: ProfileCardType.TRANSACTIONS, subType: TransactionDefType.ORDER }}
            />
          );
        })}
      </StyledOrderAttributes>
    );
  }

  renderHeader() {
    let orderAttributes = this.renderOrderAttributes();
    if (!orderAttributes) {
      return null;
    }

    return (
      <div>
        <StyledOrderNumber>Order {this.props.attributes.orderNumber}</StyledOrderNumber>
        {orderAttributes}
      </div>
    );
  }

  renderNote() {
    let note = this.props.attributes.note;
    if (!note || !note.length > 0) {
      return null;
    }
    return (
      <div>
        <StyledNoteHeader>Notes</StyledNoteHeader>
        <StyledNoteBodyContainer>{note}</StyledNoteBodyContainer>
      </div>
    );
  }

  renderAttributes() {
    return (
      <div>
        {_.map(_.get(this.props, 'attributes.products') || [], (product, idx) => {
          return (
            <AttributesWithImages key={`product-image-${idx}`} imageUrl={_.get(product, 'imageUrl')}>
              <ProductAttributes
                key={`product-${idx}`}
                product={product}
                transactionDef={this.props.transactionDef}
                isLastProduct={this.props.attributes.length - 1 === idx}
              />
            </AttributesWithImages>
          );
        })}
      </div>
    );
  }

  renderActions() {
    if (_.isEmpty(this.props.attributes.actions)) {
      return null;
    }

    return (
      <StyledActionsContainer>
        {_.map(this.props.attributes.actions, (action, idx) => {
          return (
            <StyledActionButton
              onClick={() => this.props.onOpenActionForm(this.props.customerId, action)}
              buttonType={ButtonTypes.SECONDARY}
              key={`styled-action-button-${idx}`}
            >
              {action.name}
            </StyledActionButton>
          );
        })}
      </StyledActionsContainer>
    );
  }
}

export const StyledActionButton = styled(Button)`
  margin: ${p => p.theme.spacing.medium};
`;

export const StyledActionsContainer = styled.div`
  display: flex;
  justify-content: center;
`;

ExpandedOrderTransactionBase.propTypes = {
  attributes: PropTypes.object,
  customerId: PropTypes.string,
  headerRenderer: PropTypes.func.isRequired,
  transactionDef: PropTypes.instanceOf(OrderTransactionDef).isRequired,
  onOpenActionForm: PropTypes.func.isRequired,
};

function mapExecuteToProps(executeAction) {
  return {
    onOpenActionForm: (customerId, action) => executeAction(GetExternalActionForm, { customerId, action }),
  };
}

function mapStateToProps({ getProvider }) {
  return {
    customerId: getProvider('currentLocation').get().customerId,
  };
}

export default connect(mapStateToProps, mapExecuteToProps)(ExpandedOrderTransactionBase);

export class ProductAttributes extends React.Component {
  render() {
    const { product, isLastProduct, transactionDef } = this.props;
    const classNames = classnames(
      'productAttributes-status',
      { 'productAttributes-status-fulfilled': product.status === 'fulfilled' },
      { 'productAttributes-status-cancelled': product.status === 'cancelled' },
      { 'productAttributes-status-unfulfilled': product.status !== 'fulfilled' && product.status !== 'cancelled' }
    );

    return (
      <div>
        <div className="productAttributes">
          {product.status ? <div className={classNames}>{product.status}</div> : null}
          <div className="productAttributes-name">{product.name}</div>
          {_.map(transactionDef.attributes, def => {
            const key = `productAttributes-${def.attr}`;
            return (
              <VisibleCustomAttribute
                className="transactionAttribute"
                def={def}
                key={key}
                value={product[def.attr]}
                location={{ type: ProfileCardType.TRANSACTIONS, subType: TransactionDefType.ORDER }}
              />
            );
          })}
        </div>
        {!isLastProduct ? <hr className="transaction-middleBorder" /> : null}
      </div>
    );
  }
}

ProductAttributes.propTypes = {
  attributes: PropTypes.instanceOf(OrderAttributesPropTypes),
  isLastProduct: PropTypes.bool.isRequired,
  transactionDef: PropTypes.instanceOf(OrderTransactionDef).isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/transactions/expanded_order_transaction_base.jsx